import CityPageTemplate from "../city-template/CityPageTemplate";
import { allenConfig } from "./data";

export default function AllenPage() {
  return <CityPageTemplate config={allenConfig} />;
}